import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { push } from 'connected-react-router';
import queryString from 'query-string';

import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';

import Page from '../../components/Page';
import styled from './PhotosStyles';

import { actions } from '../../services/photos';
import PhotoItem from './PhotoItem';

import Pagination from '../../components/Pagination';

class Photos extends React.Component {
  getParams() {
    const defaultParams = {
      page: 0
    };

    const parsed = queryString.parse(this.props.search);
    const params = Object.assign(defaultParams, parsed);
    params.page = parseInt(params.page);
    return params;
  }

  updateParams(newParams) {
    const params = this.getParams();
    const search = queryString.stringify(Object.assign(params, newParams));

    this.props.actions.push(this.props.pathname + '?' + search);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.search !== this.props.search) {
      const { actions } = this.props;
      actions.load(this.getParams());
    }
  }

  componentDidMount() {
    this.props.actions.load(this.getParams());
  }

  nextPage = () => {
    const { page } = this.getParams();
    this.updateParams({ page: page + 1 });
  };

  prevPage = () => {
    const { page } = this.getParams();
    this.updateParams({ page: page - 1 });
  };

  render() {
    const { classes, total, loading, photos, perPage } = this.props;
    const filters = this.getParams();
    return (
      <Page title="Photos" loading={loading}>
        <Paper>
          <Toolbar>
            <Typography>Photos - {total}</Typography>
          </Toolbar>
        </Paper>

        <div className={classes.grid}>
          {photos.map(photo => (
            <PhotoItem data={photo} key={photo._id} />
          ))}
        </div>

        <Pagination
          total={total}
          perPage={perPage}
          page={filters.page}
          onNext={this.nextPage}
          onPrev={this.prevPage}
        />
      </Page>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.photos.loading,
    photos: state.photos.photos,
    total: state.photos.total,
    perPage: state.photos.perPage,
    pathname: state.router.location.pathname,
    search: state.router.location.search
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    load: filters => dispatch(actions.load(filters)),
    push: payload => dispatch(push(payload))
  }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(styled(Photos))
);
